import React from "react";
import { theme as chakraTheme, DefaultTheme, ColorHues } from "@chakra-ui/core";
import {
  DesignLanguage,
  Diez,
  Color,
} from "@pravda/gdsn-admin-design-language";

// eslint-disable-next-line
import { forEach } from "lodash";

const designLanguage = new Diez(DesignLanguage);

const customIcons = {
  bulletList: {
    viewBox: "0 0 30 30",
    path: (
      <g>
        <path
          color="current-color"
          d="M26.2069 20.6818H11.8621C10.8723 20.6818 10.069 21.4556 10.069 22.4091C10.069 23.3625 10.8723 24.1364 11.8621 24.1364H26.2069C27.1967 24.1364 28 23.3625 28 22.4091C28 21.4556 27.1967 20.6818 26.2069 20.6818ZM26.2069 13.7727H11.8621C10.8723 13.7727 10.069 14.5465 10.069 15.5C10.069 16.4535 10.8723 17.2273 11.8621 17.2273H26.2069C27.1967 17.2273 28 16.4535 28 15.5C28 14.5465 27.1967 13.7727 26.2069 13.7727ZM11.8621 10.3182H26.2069C27.1967 10.3182 28 9.54436 28 8.59091C28 7.63745 27.1967 6.86364 26.2069 6.86364H11.8621C10.8723 6.86364 10.069 7.63745 10.069 8.59091C10.069 9.54436 10.8723 10.3182 11.8621 10.3182ZM4.68966 19.8182C3.20407 19.8182 2 20.978 2 22.4091C2 23.8401 3.20407 25 4.68966 25C6.17524 25 7.37931 23.8401 7.37931 22.4091C7.37931 20.978 6.17524 19.8182 4.68966 19.8182ZM4.68966 12.9091C3.20407 12.9091 2 14.069 2 15.5C2 16.931 3.20407 18.0909 4.68966 18.0909C6.17524 18.0909 7.37931 16.931 7.37931 15.5C7.37931 14.069 6.17524 12.9091 4.68966 12.9091ZM4.68966 6C3.20407 6 2 7.15986 2 8.59091C2 10.022 3.20407 11.1818 4.68966 11.1818C6.17524 11.1818 7.37931 10.022 7.37931 8.59091C7.37931 7.15986 6.17524 6 4.68966 6Z"
        />
      </g>
    ),
  },
  cross: {
    viewBox: "0 0 30 30",
    path: (
      <g>
        <path
          fill="currentColor"
          d="M17.7443 15L25.4258 7.31853C25.7903 6.95461 25.9954 6.46078 25.9959 5.94566C25.9963 5.43055 25.7921 4.93636 25.4282 4.5718C25.0643 4.20723 24.5705 4.00217 24.0553 4.00172C23.5402 4.00126 23.046 4.20545 22.6815 4.56937L15 12.2508L7.31853 4.56937C6.95397 4.20481 6.45952 4 5.94395 4C5.42838 4 4.93393 4.20481 4.56937 4.56937C4.20481 4.93393 4 5.42838 4 5.94395C4 6.45952 4.20481 6.95397 4.56937 7.31853L12.2508 15L4.56937 22.6815C4.20481 23.046 4 23.5405 4 24.0561C4 24.5716 4.20481 25.0661 4.56937 25.4306C4.93393 25.7952 5.42838 26 5.94395 26C6.45952 26 6.95397 25.7952 7.31853 25.4306L15 17.7492L22.6815 25.4306C23.046 25.7952 23.5405 26 24.0561 26C24.5716 26 25.0661 25.7952 25.4306 25.4306C25.7952 25.0661 26 24.5716 26 24.0561C26 23.5405 25.7952 23.046 25.4306 22.6815L17.7443 15Z"
        />
      </g>
    ),
  },
  download: {
    viewBox: "0 0 30 30",
    path: (
      <g>
        <path
          fill="current-color"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 5C15.4986 5 15.9028 5.42886 15.9028 5.95789V16.098L18.8755 12.9437C19.2281 12.5696 19.7997 12.5696 20.1523 12.9437C20.5048 13.3178 20.5048 13.9243 20.1523 14.2984L15.6384 19.0879C15.2858 19.4619 14.7142 19.4619 14.3617 19.0879L9.84776 14.2984C9.4952 13.9243 9.4952 13.3178 9.84776 12.9437C10.2003 12.5696 10.7719 12.5696 11.1245 12.9437L14.0972 16.098V5.95789C14.0972 5.42886 14.5014 5 15 5Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.92857 17.1579C3.44141 17.1579 3.85714 17.5538 3.85714 18.0421V21.579C3.85714 23.044 5.10435 24.2316 6.64286 24.2316H23.3571C24.8957 24.2316 26.1429 23.044 26.1429 21.579V18.0421C26.1429 17.5538 26.5586 17.1579 27.0714 17.1579C27.5843 17.1579 28 17.5538 28 18.0421V21.579C28 24.0206 25.9213 26 23.3571 26H6.64286C4.07868 26 2 24.0206 2 21.579V18.0421C2 17.5538 2.41574 17.1579 2.92857 17.1579Z"
        />
      </g>
    ),
  },
  filter: {
    viewBox: "0 0 30 30",
    path: (
      <path d="M24.9677 4H5.03245C4.11644 4 3.65423 5.06091 4.30327 5.68045L12.25 13.2671V21.7187C12.25 22.0399 12.4142 22.341 12.6899 22.5252L16.1274 24.8212C16.8055 25.2744 17.75 24.8151 17.75 24.0148V13.2671L25.6969 5.68045C26.3446 5.06214 25.8856 4 24.9677 4Z" />
    ),
  },

  settings: {
    viewBox: "0 0 30 30",
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.4279 19.1671L22.6293 17.5383L22.8252 16.4683C22.9175 15.9641 22.9727 15.4808 22.9727 15C22.9727 14.5199 22.9175 14.0358 22.8252 13.5317L22.6293 12.4617L25.4279 10.8329C25.4343 10.8292 25.4376 10.8259 25.44 10.8227C25.4431 10.8186 25.4468 10.8119 25.4492 10.8027C25.4517 10.7935 25.4521 10.7847 25.4512 10.7775C25.4504 10.7715 25.4486 10.7646 25.4435 10.7556L23.8566 7.98369C23.8516 7.97501 23.8475 7.97134 23.8452 7.9696C23.8421 7.96719 23.8378 7.96496 23.8328 7.9636C23.8277 7.96224 23.8223 7.96253 23.8223 7.96253C23.8223 7.96253 23.819 7.96291 23.8132 7.96629L23.8115 7.9673L20.9826 9.61247L20.1474 8.89614C19.3932 8.24935 18.5581 7.73928 17.6525 7.41566L16.6253 7.04852V4.6C16.6253 4.58839 16.6232 4.5814 16.6211 4.57645C16.6186 4.5705 16.6147 4.56442 16.6094 4.55913C16.6042 4.55385 16.5995 4.55118 16.5968 4.55005C16.5968 4.55005 16.5928 4.54839 16.5864 4.54839H13.4135C13.4071 4.54839 13.403 4.55005 13.403 4.55005C13.4003 4.55118 13.3956 4.55385 13.3904 4.55913C13.3852 4.56442 13.3812 4.5705 13.3787 4.57645C13.3766 4.5814 13.3746 4.58839 13.3746 4.6V7.04852L12.3473 7.41566C11.4418 7.73928 10.6066 8.24935 9.85248 8.89614L9.01723 9.61247L6.18663 7.96629C6.18058 7.96276 6.17753 7.96253 6.17753 7.96253C6.17753 7.96253 6.17211 7.96224 6.16708 7.9636C6.16203 7.96496 6.15776 7.96719 6.1546 7.9696C6.15232 7.97134 6.1484 7.97473 6.14344 7.9834L4.55637 10.7556C4.55132 10.7645 4.54956 10.7711 4.54882 10.7771C4.54794 10.7842 4.54832 10.793 4.5508 10.8024C4.55329 10.8117 4.55707 10.8186 4.56028 10.8229C4.56278 10.8263 4.56585 10.8294 4.57213 10.8331L7.37053 12.4617L7.17461 13.5317C7.08231 14.0358 7.02712 14.5199 7.02712 15C7.02712 15.4808 7.08229 15.9641 7.17461 16.4683L7.37053 17.5383L4.57218 19.1669C4.56587 19.1706 4.56279 19.1737 4.56028 19.1771C4.55707 19.1814 4.55329 19.1883 4.5508 19.1976C4.54832 19.207 4.54794 19.2158 4.54882 19.2229C4.54956 19.2289 4.55132 19.2355 4.55637 19.2444L6.14327 22.0163C6.14824 22.025 6.15232 22.0287 6.1546 22.0304C6.15776 22.0328 6.16203 22.035 6.16708 22.0364C6.17211 22.0378 6.17753 22.0375 6.17753 22.0375C6.17753 22.0375 6.18085 22.0371 6.18663 22.0337L6.18837 22.0327L9.01723 20.3875L9.85248 21.1039C10.6072 21.7511 11.4421 22.2615 12.3463 22.584L13.3746 22.9507V25.4C13.3746 25.4116 13.3766 25.4186 13.3787 25.4235C13.3812 25.4295 13.3852 25.4356 13.3904 25.4409C13.3956 25.4461 13.4003 25.4488 13.403 25.45C13.403 25.45 13.4071 25.4516 13.4135 25.4516H16.5864C16.5928 25.4516 16.5968 25.45 16.5968 25.45C16.5995 25.4488 16.6042 25.4461 16.6094 25.4409C16.6147 25.4356 16.6186 25.4295 16.6211 25.4235C16.6232 25.4186 16.6253 25.4116 16.6253 25.4V22.9507L17.6535 22.584C18.5578 22.2615 19.3926 21.7511 20.1474 21.1039L20.9826 20.3875L23.8132 22.0337C23.8193 22.0372 23.8223 22.0375 23.8223 22.0375C23.8223 22.0375 23.8277 22.0378 23.8328 22.0364C23.8378 22.035 23.8421 22.0328 23.8452 22.0304C23.8475 22.0287 23.8514 22.0253 23.8564 22.0166L25.4435 19.2444C25.4486 19.2354 25.4504 19.2285 25.4512 19.2225C25.4521 19.2153 25.4517 19.2065 25.4492 19.1973C25.4468 19.1881 25.4431 19.1814 25.44 19.1773C25.4376 19.1741 25.4343 19.1708 25.4279 19.1671ZM3.79307 17.8288L5.65155 16.7472C5.54754 16.1792 5.47874 15.5992 5.47874 15C5.47874 14.4016 5.54754 13.8208 5.65155 13.2528L3.79307 12.1712C3.03464 11.7296 2.77463 10.7504 3.21305 9.9856L4.79951 7.2144C5.23713 6.4496 6.20837 6.18641 6.9668 6.62881L8.84447 7.7208C9.7213 6.9688 10.7181 6.35359 11.8262 5.95759V4.6C11.8262 3.7168 12.5366 3 13.4135 3H16.5864C17.4632 3 18.1736 3.7168 18.1736 4.6V5.95759C19.2817 6.35359 20.2785 6.9688 21.1554 7.7208L23.033 6.62881C23.7915 6.18641 24.7627 6.4496 25.2003 7.2144L26.7868 9.9856C27.2252 10.7504 26.966 11.7296 26.2068 12.1712L24.3483 13.2528C24.4523 13.8208 24.5211 14.4016 24.5211 15C24.5211 15.5992 24.4523 16.1792 24.3483 16.7472L26.2068 17.8288C26.966 18.2704 27.2252 19.2496 26.7868 20.0144L25.2003 22.7856C24.7627 23.5504 23.7915 23.8136 23.033 23.3712L21.1554 22.2792C20.2785 23.0312 19.2817 23.6472 18.1736 24.0424V25.4C18.1736 26.2832 17.4632 27 16.5864 27H13.4135C12.5366 27 11.8262 26.2832 11.8262 25.4V24.0424C10.7181 23.6472 9.7213 23.0312 8.84447 22.2792L6.9668 23.3712C6.20837 23.8136 5.23713 23.5504 4.79951 22.7856L3.21305 20.0144C2.77463 19.2496 3.03464 18.2704 3.79307 17.8288ZM14.9999 20.5484C11.9412 20.5484 9.48497 18.0524 9.48497 15C9.48497 11.9476 11.9412 9.45161 14.9999 9.45161C18.0582 9.45161 20.5157 11.9472 20.5157 15C20.5157 18.0528 18.0582 20.5484 14.9999 20.5484ZM11.0334 15C11.0334 17.2096 12.8086 19 14.9999 19C17.1912 19 18.9673 17.2096 18.9673 15C18.9673 12.7904 17.1912 11 14.9999 11C12.8086 11 11.0334 12.7904 11.0334 15Z"
      />
    ),
  },

  search: {
    viewBox: "0 0 30 30",
    path: (
      <g>
        <path
          fillRule="evenodd"
          fill="currentColor"
          clipRule="evenodd"
          d="M13.6 21.8923C18.1797 21.8923 21.8923 18.1797 21.8923 13.6C21.8923 9.02029 18.1797 5.3077 13.6 5.3077C9.0203 5.3077 5.30771 9.02029 5.30771 13.6C5.30771 18.1797 9.0203 21.8923 13.6 21.8923ZM13.6 23.4C19.0124 23.4 23.4 19.0124 23.4 13.6C23.4 8.18761 19.0124 3.8 13.6 3.8C8.18763 3.8 3.80002 8.18761 3.80002 13.6C3.80002 19.0124 8.18763 23.4 13.6 23.4Z"
        />
        <path
          fillRule="evenodd"
          fill="currentColor"
          clipRule="evenodd"
          d="M19.1796 21.0667L19.522 20.377L24.7096 25.5646C25.0172 25.8722 25.0355 26.3526 24.7505 26.6376C24.4655 26.9226 23.9851 26.9043 23.6775 26.5967L18.4899 21.4091L19.1796 21.0667Z"
        />
      </g>
    ),
  },

  upload: {
    viewBox: "0 0 30 30",
    path: (
      <g>
        <path
          d="M22.0864 11.4282L21.5997 11.4485C20.4603 8.22556 17.0201 6 13.4444 6C8.86904 6 4.80247 9.65045 4.80247 14.1423V14.3133C3.41975 14.9171 1 17.0464 1 19.5718C1 22.5655 3.82627 25 6.87654 25H22.0864C25.8986 25 29 21.9548 29 18.2148C29 14.4748 25.8986 11.4282 22.0864 11.4282ZM22.0864 22.2859H15.8642V17.1373L18.8315 20.0495C18.967 20.1838 19.144 20.2476 19.321 20.2476C19.498 20.2476 19.675 20.1811 19.8105 20.0495C20.0801 19.7862 20.0801 19.3547 19.8105 19.0901L15.6651 15.0189L15.4383 14.8737C15.2682 14.8045 15.0788 14.8045 14.9087 14.8737L14.6847 15.0189L10.5366 19.0901C10.2683 19.3547 10.2683 19.7862 10.5366 20.0495C10.6735 20.1838 10.8505 20.2476 11.0261 20.2476C11.2017 20.2476 11.38 20.1811 11.5156 20.0495L14.4815 17.1373V22.2859H6.87654C5.35002 22.2859 4.11111 21.07 4.11111 19.5718C4.11111 18.0736 5.35002 16.8577 6.74933 16.8509L8.71556 16.8713L8.37264 15.2415C8.29659 14.8832 8.25926 14.5141 8.25926 14.1436C8.25926 11.15 10.7399 8.71545 13.7901 8.71545C16.4878 8.71545 18.7734 10.618 19.2242 13.2398L19.4828 14.7353L20.9664 14.32C21.3978 14.1993 21.7532 14.1436 22.0892 14.1436C24.3748 14.1436 26.2373 15.9702 26.2373 18.2148C26.2373 20.4593 24.3734 22.2859 22.0864 22.2859Z"
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </g>
    ),
  },
};

const colorVariant = (colors: any, colorString: string): ColorHues => {
  let modified: ColorHues = {};
  forEach(colors, (color: Color, key: string) => {
    if (key.includes(colorString)) {
      const variantNumber = parseInt(key.replace(/[^0-9]/g, ""));
      if (variantNumber >= 50 && variantNumber <= 900) {
        let colorElement = {
          [variantNumber]: color.color,
        };
        Object.assign(modified, colorElement);
      }
    }
  });
  return modified;
};

let customTheme: DefaultTheme = chakraTheme;

designLanguage.attach((ds: DesignLanguage) => {
  customTheme = {
    ...chakraTheme,
    icons: {
      ...chakraTheme.icons,
      ...customIcons,
    },
    logo: ds.images.logo,
    colors: {
      ...chakraTheme.colors,
      text: chakraTheme.colors.white,
      blue: colorVariant(ds.colors, "blue"),
      gray: colorVariant(ds.colors, "gray"),
      green: colorVariant(ds.colors, "green"),
      red: colorVariant(ds.colors, "red"),
      background: ds.palette.bodyBackground.color,
      primary: {
        dark: ds.palette.primaryDark.color,
        regular: ds.palette.primary.color,
        light: ds.palette.primaryLight.color,
      },
      secondary: {
        dark: ds.palette.secondaryDark.color,
        regular: ds.palette.secondary.color,
        light: ds.palette.primaryLight.color,
      },
    },
    sizes: {
      ...chakraTheme.sizes,
      ...ds.sizes,
    },
    zIndices: {
      ...chakraTheme.zIndices,
    },
    radii: ds.radius,
    //fontSizes: ds.fontSizes,
    shadows: {
      ...chakraTheme.shadows,
      sm: ds.shadows.shadowSm.boxShadow,
      md: ds.shadows.shadowMd.boxShadow,
      lg: ds.shadows.shadowLg.boxShadow,
      xl: ds.shadows.shadowXl.boxShadow,
    },
    fonts: {
      ...chakraTheme.fonts,
      heading: "Open Sans",
      body: "Open Sans",
    },
    fontSizes: {
      ...chakraTheme.fontSizes,
      baseFontSize: "16px",
    },
  };
});

export default customTheme;
